var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChallenge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 18.75H7.50001M16.5 18.75C18.1569 18.75 19.5 20.0931 19.5 21.75H4.50001C4.50001 20.0931 5.84316 18.75 7.50001 18.75M16.5 18.75V15.375C16.5 14.7537 15.9963 14.25 15.375 14.25H14.5034M7.50001 18.75V15.375C7.50001 14.7537 8.00369 14.25 8.62501 14.25H9.49665M14.5034 14.25H9.49665M14.5034 14.25C13.956 13.3038 13.6095 12.227 13.5219 11.0777M9.49665 14.25C10.044 13.3038 10.3905 12.227 10.4781 11.0777M5.25001 4.23636C4.26771 4.3792 3.29537 4.55275 2.33398 4.75601C2.7843 7.42349 4.99494 9.49282 7.72966 9.72775M5.25001 4.23636V4.5C5.25001 6.60778 6.21612 8.48992 7.72966 9.72775M5.25001 4.23636V2.72089C7.45544 2.41051 9.70898 2.25 12 2.25C14.291 2.25 16.5446 2.41051 18.75 2.72089V4.23636M7.72966 9.72775C8.51724 10.3719 9.45304 10.8415 10.4781 11.0777M18.75 4.23636V4.5C18.75 6.60778 17.7839 8.48992 16.2704 9.72775M18.75 4.23636C19.7323 4.3792 20.7047 4.55275 21.6661 4.75601C21.2157 7.42349 19.0051 9.49282 16.2704 9.72775M16.2704 9.72775C15.4828 10.3719 14.547 10.8415 13.5219 11.0777M13.5219 11.0777C13.0328 11.1904 12.5234 11.25 12 11.25C11.4767 11.25 10.9672 11.1904 10.4781 11.0777",
    stroke: "#46494B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChallenge);
export default __webpack_public_path__ + "static/media/challenge.55bd2dc99c4df416b3cc3b17f795993c.svg";
export { ForwardRef as ReactComponent };